import React from "react";
import "./InfoModal.css";
import { useTranslation } from "react-i18next";

/**
 * Reusable Bootstrap modal for lightweight info/help content.
 *
 * Props:
 * - modalId: string (required)
 * - title: string (required)
 * - body: string | ReactNode (required)
 * - icon: string (optional, emoji)
 */
export default function InfoModal({ modalId, title, body, icon = "ℹ️" }) {
  const { t } = useTranslation();

  return (
    <div className="modal fade" id={modalId} tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content as-theme as-info-modal">
          <div className="modal-header">
            <div className="as-info-modal-header">
              <div className="as-info-modal-title">
                <span className="as-modal-icon-badge" aria-hidden="true">
                  {icon}
                </span>
                <h5 className="modal-title">{title}</h5>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label={t("general.close")}
              />
            </div>
          </div>
          <div className="modal-body">
            {typeof body === "string" ? <p className="mb-0">{body}</p> : body}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-sm as-btn-soft"
              data-bs-dismiss="modal"
            >
              {t("general.close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

